import { render, staticRenderFns } from "./HRPatientDetails.vue?vue&type=template&id=f3d34594"
import script from "./HRPatientDetails.vue?vue&type=script&lang=js"
export * from "./HRPatientDetails.vue?vue&type=script&lang=js"
import style0 from "./HRPatientDetails.vue?vue&type=style&index=0&id=f3d34594&prod&lang=scss"
import style1 from "./HRPatientDetails.vue?vue&type=style&index=1&id=f3d34594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports